module.exports = __webpack_public_path__ + "media/images/tour/zh-hant-3cf27f7731e52da94098c0d95ba2f220.png";